export class ExportarArchivoBancoRequest {
  public idsComprobantes: number[] = []
  /** Si va vacío, el back usa el banco de la cuenta contable por defecto */
  public idBanco?: number | null
}

export class ExportarArchivoBancoResponse {
  public fileContent!: string
  public fileName!: string
  public cantidadTransferencias!: number
  public totalImporte!: number
  /** Liquidaciones que no entraron por forma de pago o por estar anuladas */
  public comprobantesExcluidos!: number
  public message!: string
}
